import type { StrandAsset } from "../../../strand-losses-manager/models/StrandAsset";
import type { Strand } from "../../models/caster.models";

export const getStrandAssets = (strands: Strand[]): StrandAsset[] =>
  strands.flatMap((strand) => {
    if (strand.StrandsParentAssetId === null || strand.StrandAssetId === null) {
      return [];
    }

    return [
      {
        AssetId: strand.StrandAssetId,
        ParentAssetId: strand.StrandsParentAssetId,
        AssetName: `Strand ${strand.Strand}`,
      },
    ];
  });
